import { Grid } from '@mantine/core';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const PipelineStats = ({ period, stats, pipeline }) => {
  let statsEl;
  if (!stats) {
    statsEl = (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  } else {
    statsEl = (
      <>
        <Grid.Col span={12}>
          <Grid>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic title="Sent" stats={stats} stat="sent" id={pipeline.id} statKey="count" />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Captured"
                stats={stats}
                stat="captured"
                percentageOfStat="sent"
                id={pipeline.id}
                statKey="count"
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic title="Processed" stats={stats} stat="processed" id={pipeline.id} statKey="count" />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Failed"
                stats={stats}
                stat="failed"
                percentageOfStat="captured"
                id={pipeline.id}
                statKey="count"
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </>
    );
  }

  return statsEl;
};

export default PipelineStats;
